module.exports = {
  capture: () => {},
};
